export default {"root": () => import('@localSearchIndexroot')}